import React, { useState, useEffect } from 'react'
import MasterLayout from '../../masterLayout/MasterLayout'
import Breadcrumb from '../../components/Breadcrumb'
import { Icon } from '@iconify/react/dist/iconify.js'
import { getContactInquiryApi } from '../../helper/apiHelper'
import toast from 'react-hot-toast'
const ContactList = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [corporateBooking, setCorporateBooking] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState("");
    const [showMessageModal, setShowMessageModal] = useState(false);

    // Fetch contact inquiries on mount
    useEffect(() => {
        fetchContactInquiries();
    }, []);

    const fetchContactInquiries = async () => {
        try {
            setIsLoading(true);
            const response = await getContactInquiryApi();
            setCorporateBooking(response.data || []);
        } catch (error) {
            toast.error(error || "Failed to fetch contact inquiries");
        } finally {
            setIsLoading(false);
        }
    };

    const handleViewMessage = (message) => {
        setSelectedMessage(message);
        setShowMessageModal(true);
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-indexed
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };




    const filteredBooking = corporateBooking?.filter((guards) => {
        const search = searchTerm?.toLowerCase();

        return Object.entries(guards)
            .filter(([key]) =>
                ["companyName", "mobileNumber", "name", "email"].includes(key)
            )
            .some(([_, value]) =>
                String(value)?.toLowerCase().includes(search)
            );
    });


    const [currentPage, setCurrentPage] = useState(1);

    const [itemsPerPage] = useState(10);
    const totalItems = corporateBooking?.length || 0;
    const itemsPerPageSafe = itemsPerPage || 1;
    const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
    const startIdx = (currentPage - 1) * itemsPerPage;
    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <MasterLayout>
            <Breadcrumb title="Contact List" />

            <div className="col-lg-12">
                <div className="card">
                    <div className="card-header" style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", alignItems: "center", gap: "0.7rem" }}>
                        <h5 className="card-title mb-0">Contact List</h5>


                        <form className="navbar-search d-flex align-items-center gap-2">
                            <input
                                type="text"
                                className="bg-base h-40-px w-auto form-control"
                                name="search"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>

                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            {isLoading ? (
                                <div className="text-center py-40">
                                    <div className="spinner-border text-primary" role="status" />
                                </div>
                            ) : filteredBooking?.length === 0 ? (
                                <div className="text-center py-40 text-muted fw-medium">No contacts found.</div>
                            ) : (
                                <table className="table basic-border-table mb-0">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Message</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredBooking?.slice(startIdx, startIdx + itemsPerPage)?.map((items, index) => (
                                            <tr key={index}>
                                                <td>{formatDate(items.createdAt)}</td>
                                                <td>{items.name}</td>
                                                <td>{items.email}</td>
                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-outline-primary radius-8"
                                                        onClick={() => handleViewMessage(items.message)}
                                                    >
                                                        View Message
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>


                        {filteredBooking?.length > itemsPerPage &&


                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24 mb-10">
                                <span>
                                    Showing {startIdx + 1} to{" "}
                                    {Math.min(startIdx + itemsPerPage, filteredBooking?.length)} of{" "}
                                    {filteredBooking?.length} entries
                                </span>
                                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                                    <li className="page-item">
                                        <button
                                            className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                            onClick={() => goToPage(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            <Icon icon="ep:d-arrow-left" className="text-xl" />
                                        </button>
                                    </li>

                                    {[...Array(totalPages)].map((_, index) => (
                                        <li className="page-item" key={index}>
                                            <button
                                                className={`page-link ${currentPage === index + 1
                                                    ? "bg-primary-600 text-white"
                                                    : "bg-primary-50 text-secondary-light"
                                                    } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                                                onClick={() => goToPage(index + 1)}
                                            >
                                                {index + 1}
                                            </button>
                                        </li>
                                    ))}

                                    <li className="page-item">
                                        <button
                                            className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                            onClick={() => goToPage(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            <Icon icon="ep:d-arrow-right" className="text-xl" />
                                        </button>
                                    </li>
                                </ul>
                            </div>}

                    </div>
                </div>
                {/* card end */}
            </div>

            {showMessageModal && (
                <>
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div
                            className="modal-dialog modal-md modal-dialog-centered"
                            style={{ zIndex: 11122 }}
                        >
                            <div className="modal-content radius-16 bg-base">
                                <div className="modal-header py-16 px-24 border-bottom">
                                    <h1 className="modal-title fs-5">Message</h1>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowMessageModal(false)}
                                    />
                                </div>

                                <div className="modal-body p-24">
                                    <p className="text-secondary-light" style={{ wordBreak: 'break-word' }}>{selectedMessage}</p>
                                    <div className="d-flex justify-content-end mt-24">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => setShowMessageModal(false)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Modal backdrop */}
                        <div
                            className="modal-backdrop fade show"
                            style={{ zIndex: 1040 }}
                        />
                    </div>
                </>
            )}
        </MasterLayout>
    );
}

export default ContactList